// extracted by mini-css-extract-plugin
module.exports = {"buttons":"ConfirmModal_buttons__3gATZ","alertIcon":"ConfirmModal_alertIcon__j_9Mg"};